import AddUpdateCurrencyRate from './AddUpdateCurrencyRate';

export default AddUpdateCurrencyRate;
